import { routeApis } from "../../constants/apis";
import { RequestMethods } from "../../constants/fetch";
import { Routes } from "../../constants/routes";
import { fetchJSON, setFetchOpts } from "../../helpers/fetch";
import { getPageData } from "../templates/page";
import { getPortalHubs } from "./pendingRegistrations";

export const getUserStatuses = async (url: string) => {
  const fetchOptions = setFetchOpts({
    method: RequestMethods.GET,
  });

  const { data } = await fetchJSON(url, fetchOptions, 10000);

  return data;
};

export const portalUsersLoader = async (props: any) => {
  const portalRegions = await getPortalHubs(
    routeApis[Routes.PORTAL_USERS].getPortalHubs
  );

  const userStatuses = await getUserStatuses(
    routeApis[Routes.PORTAL_USERS].getUserStatuses
  );

  return getPageData({
    url: routeApis[Routes.PORTAL_USERS].portalUsers,
    passThroughData: {
      queryBannerFilterConfig: {
        portalRegions,
        userStatuses,
      },
    },
    ...props,
  });
};
